// Import app styles
import "./styles/main.scss";

// Add assets to /dist
import "./assets/favicon.ico";
import "./assets/logo-white.png";
import "./assets/logout.png";
import "./assets/small-logo-white.svg";
import "./assets/small-logo-active.svg";

// Add polyfills
import "core-js/es6/promise";
import "core-js/es6/array";

import "vue-simple-suggest/dist/styles.css";
